<template>
  <v-card-text>
    <v-chip outline small class="primary primary--text">{{ $t(`service.meta.${service.service_type}`) }}</v-chip>
    <v-chip
      v-for="option in options" :key="option.key"
      outline small class="secondary secondary--text">
      {{ $t(`service.meta.options.${option.key}`, { value: option.value }) }}
    </v-chip>
  </v-card-text>
</template>

<script>
  export default {
    props: {
      service: {
        type: Object,
        required: true
      }
    },
    computed: {
      options () {
        return Object.keys(this.service.service_options)
          .filter(key => this.service.service_options[key])
          .filter(key => key !== 'message')
          .map(key => this.processOption(key))
      }
    },
    methods: {
      processOption (key) {
        const value = this.service.service_options[key]
        if (key === 'response_delay') {
          return {
            key: value.split('.')[1],
            value: value.split('.')[0]
          }
        }
        if (key === 'service_type') {
          return {
            key: key,
            value: this.$t(`service.meta.services.${value}`)
          }
        }
        return {
          key,
          value
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/service/Meta.vue